import React, { useState, useEffect } from "react";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import axios from "axios";
import { Table } from "react-bootstrap";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";

function Slider_Setting(props) {
    const [setting, setSetting] = useState({
        enable_slider_title: 1,
        enable_slider_description: 1,
        enable_watchnow_button: 1,
        enable_cta_button: 1,
        enable_more_details_button: 1,
        enable_slider_duration: 1,
        enable_category: 1,
        enable_language: 1,
        enable_publish_year: 1,
    });

    const [processing, setProcessing] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const access_token = localStorage.getItem("access_token");

    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/slider-settings/index`, {
                    headers,
                });
                if (response?.data?.status) {
                    setSetting(response.data.sliderSetting);
                }
            } catch (error) {
                console.error("Error fetching slider settings:", error);
            }
        })();
    }, []);

    const handleInput = (e) => {
        const { name, checked } = e.target;
        setSetting({ ...setting, [name]: checked ? 1 : 0 });
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setProcessing(true);
        setShowOverlay(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_Baseurl}/admin/slider-settings/update`,
                setting,
                { headers }
            );

            const result = response?.data;
            if (result?.status) {
                props?.setApiresponsealert(result);
                props?.setShowalert(true);
                setTimeout(() => {
                    setProcessing(false);
                    setShowOverlay(false);
                }, 2000);
            } else {
                props?.setApiresponsealert(result);
                props?.setShowalert(true);
                setProcessing(false);
                setShowOverlay(false);
            }
        } catch (error) {
            console.error("Error updating slider settings:", error);
            setProcessing(false);
            setShowOverlay(false);
        }
    };

    const settingsList = [
        { label: "Enable Slider Title", name: "enable_slider_title" },
        { label: "Enable Slider Description", name: "enable_slider_description" },
        { label: "Enable Watch Now Button", name: "enable_watchnow_button" },
        { label: "Enable CTA Button", name: "enable_cta_button" },
        { label: "Enable More Details Button", name: "enable_more_details_button" },
        { label: "Enable Slider Duration", name: "enable_slider_duration" },
        { label: "Enable Category", name: "enable_category" },
        { label: "Enable Language", name: "enable_language" },
        { label: "Enable Publish Year", name: "enable_publish_year" },
    ];

    return (
        <div className="m-0 p-0">
            <AdminBackNavigation path="/settings" text="Back" />
            <section className="section container-fluid">
                <div className="row py-3">
                    <div className="col-6">
                        <h4 className="admin-title mb-0 theme-text-color">Slider Settings</h4>
                    </div>
                    <div className="col-6 text-end">
                        <button
                            onClick={handleUpdate}
                            className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                        >
                            Update
                        </button>
                    </div>
                </div>

                {showOverlay && <Response_Processing />}

                <div className="iq-card">
                    <div className="panel-body">
                        <div className="col-lg-12">
                            <Table>
                                <thead>
                                    <tr className="title">
                                        <th className="fs-5 theme-text-color admin-input-title">Settings</th>
                                        <th className="fs-5 theme-text-color admin-input-title">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {settingsList.map((item) => (
                                        <tr key={item.name}>
                                            <td>
                                                <p className="theme-text-color mb-3 mt-0 admin-input-title">{item.label}</p>
                                            </td>
                                            <td>
                                                <div className="mt-1">
                                                    <AdminSwitch
                                                        name={item.name}
                                                        checked={setting?.[item.name] === 1}
                                                        onChange={handleInput}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Slider_Setting;
